<template>
  <div>
    <s-table
      class="load-simulation__table"
      sticky-header
      :busy="loading"
      :items="reports"
      :fields="fields">
      <template #thead-top>
        <b-tr>
          <b-th
            class="load-simulation__list-header"
            colspan="1"
            rowspan="2">
            {{ $t("fields.engineering.load-simulation.point")}}
          </b-th>
          <b-th
            class="load-simulation__list-header"
            colspan="1"
            rowspan="2">
            {{ $t("fields.engineering.load-simulation.dateTime")}}
          </b-th>
          <b-th
            class="load-simulation__list-header"
            colspan="1"
            rowspan="2">
            {{ $t("fields.engineering.load-simulation.environmentTemperature")}}
          </b-th>
          <b-th
            class="load-simulation__list-header"
            colspan="1"
            rowspan="2">
            {{ $t("fields.engineering.load-simulation.loading")}}
          </b-th>
          <b-th
            class="load-simulation__list-header"
            colspan="1"
            rowspan="2">
            {{ $t("fields.engineering.load-simulation.oilTemperature")}}
          </b-th>
          <b-th
            class="load-simulation__list-header"
            colspan="1"
            rowspan="2">
            {{ $t("fields.engineering.load-simulation.windingTemperature")}}
          </b-th>
          <b-th
            class="load-simulation__list-header"
            colspan="1"
            rowspan="2">
            {{ $t("fields.engineering.load-simulation.lossLife")}}
          </b-th>
          <b-th
            class="load-simulation__list-header"
            colspan="2"
            rowspan="1">
            {{ $t("fields.engineering.load-simulation.oil")}}
          </b-th>
          <b-th
            class="load-simulation__list-header"
            colspan="2"
            rowspan="1">
            {{ $t("fields.engineering.load-simulation.winding")}}
          </b-th>
          <b-th
            class="load-simulation__list-header"
            colspan="2"
            rowspan="2">
            {{ $t("fields.engineering.load-simulation.coolingStages")}}
          </b-th>
        </b-tr>
      </template>
      <template #cell(dateTime)="data">
        {{ data.item.dateTime | dateTimeFilter({ format:formats.DATETIME_SHORT }) }}
      </template>
      <template #cell(oilTemperature)="data">
        <span :class="getAlarmOrShutdownClass(data.item.oilAlarm, data.item.oilShutdown)">
          {{ data.item.oilTemperature }}
        </span>
      </template>
      <template #cell(windingTemperature)="data">
        <span :class="getAlarmOrShutdownClass(data.item.windingAlarm, data.item.windingShutdown)">
          {{ data.item.windingTemperature }}
        </span>
      </template>
      <template #cell(oilAlarm)="data">
        <icon-badge
          :icon-color="data.item.oilAlarm ? 'var(--color-danger)' : ''"
          :icon-class="data.item.oilAlarm ? 'fas fa-bell' : 'fas fa-minus'"
          :outlined="false"
        />
      </template>
      <template #cell(oilShutdown)="data">
        <icon-badge
          :icon-color="data.item.oilShutdown ? 'var(--color-danger)' : ''"
          :icon-class="data.item.oilShutdown ? 'fas fa-bell' : 'fas fa-minus'"
          :outlined="false"
        />
      </template>
      <template #cell(windingAlarm)="data">
        <icon-badge
          :icon-color="data.item.windingAlarm ? 'var(--color-danger)' : ''"
          :icon-class="data.item.windingAlarm ? 'fas fa-bell' : 'fas fa-minus'"
          :outlined="false"
        />
      </template>
      <template #cell(windingShutdown)="data">
        <icon-badge
          :icon-color="data.item.windingShutdown ? 'var(--color-danger)' : ''"
          :icon-class="data.item.windingShutdown ? 'fas fa-bell' : 'fas fa-minus'"
          :outlined="false"
        />
      </template>
    </s-table>
    <grid-paginator
      v-model="pageHandler"
      :per-page="pagination.pageSize"
      :total-rows="pagination.totalRows"
    />
  </div>
</template>
<script>
import resultListFields
  from '@/domain/data/installation/engineering/loadSimulation/resultListFields.json';
import GridPaginator from '@/components/lists/Paginator';
import { formats } from '@/constants/localizer';
import IconBadge from '@/components/icon/IconBadge';

export default {
  name: 'LoadSimulationResultList',
  props: {
    reports: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
    pagination: {
      type: Object,
      default: () => ({
        pageSize: 50,
        page: 1,
        totalRows: null,
      }),
    },
  },
  components: {
    GridPaginator,
    IconBadge,
  },
  data: () => ({ formats }),
  computed: {
    pageHandler: {
      get() {
        return this.pagination.page;
      },
      set(newPage) {
        this.$emit('page-changed', newPage);
      },
    },
    fields() {
      return resultListFields.map(item => ({
        key: item.key,
        label: this.$t(item.label),
        thStyle: item.thStyle,
      }));
    },
  },
  methods: {
    getAlarmOrShutdownClass(alarm, shutdown) {
      return { 'text-danger': alarm || shutdown };
    },
  },
};
</script>
<style lang="sass" scoped>
.load-simulation__list-header
  height: 1rem
  background-color: var(--color-gray-medium-highlight) !important

::v-deep
  .e-chart
    border: none
  .table th, .table td
    padding: .25rem .5rem
    white-space: normal !important
    min-width: auto !important
    border-right: var(--color-background-light) .25rem solid
    border-left:  var(--color-background-light) .25rem solid
    &[aria-colindex="2"]
      white-space: nowrap !important
    &:first-child
      text-align: center !important
      border-left: none
    &:last-child
      text-align: center !important
      border-right: none
      min-width: 50px
  .table tbody
    overflow-y: auto

  @media print
    .badge
      border: none
    .table th
      top: 0 !important
      padding: .25rem .1rem
      font-size: 0.7em
      background-color: var(--color-gray-medium-highlight) !important
    .table td
      font-size: 1em

</style>
